import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';

@Injectable()
export class AppExportService {
    documentStorageUrl = "";
    constructor(private http: HttpClient) {
        this.documentStorageUrl = environment.documentStorageUrl;
    }

    // saveFileWithColumns(organizationId, loginUserId, objectId, typeId, isActive, filter, fieldList, pageNumber = 0, pageSize = 0) {

    //     let fieldListStr = "";
    //     if (fieldList) {
    //         fieldListStr = `&fieldList=${fieldList}`;
    //     }
    //     let url = '&loginUserId=' + loginUserId + '&objectId=' + objectId + '&typeId=' + typeId + '&stageId=0&pageNumber=' + pageNumber + '&pageSize=' 
    //     + pageSize + '&filter=' + filter + '&isActive=' + isActive + '&SortBy=createdDate&IsAscending=false'
    //     let urls = this.documentStorageUrl + 'SaveAsCSV?organizationId=' + organizationId + url + fieldListStr;

    //     return this.http.get<any>(urls)
    //         .toPromise()
    //         .then(res => res);
    // }

    ExportData(data: any){
        return this.http.post<any>(`${environment.apiUrl}ExportFile`, data);
    }

}
